import CustomerList from "../../components/customer/CustomerList";


const Customers=()=>{

  return <>
  <CustomerList />
  </>
}

export default Customers;